export const ASSESSMENT_CONFIG = {
  title: "System Diagnostic",
  sections: [
    {
      id: "operator",
      title: "The Operator",
      desc: "Stress, sleep, and recovery capacity.",
      questions: [
        {
          id: "sleep",
          label: "Average nightly sleep?",
          options: [
            { label: "< 5 hours", value: "critical", tag: "elevated" },
            { label: "5–6 hours", value: "low", tag: "contributing" },
            { label: "7+ hours", value: "optimal", tag: "neutral" },
          ],
        },
        {
          id: "stress",
          label: "Current life stress load?",
          options: [
            { label: "Redline (Overwhelmed)", value: "high", tag: "elevated" },
            { label: "Manageable", value: "med", tag: "neutral" },
            { label: "Low / Zen", value: "low", tag: "neutral" },
          ],
        },
      ],
    },
    {
      id: "machine",
      title: "The Machine",
      desc: "Pain, injury history, and structural integrity.",
      questions: [
        {
          id: "pain_current",
          label: "Are you in pain right now?",
          options: [
            { label: "Yes, sharp/limiting", value: "yes_bad", tag: "elevated" },
            {
              label: "Just dull aches/stiffness",
              value: "yes_mild",
              tag: "contributing",
            },
            { label: "No, feel good", value: "no", tag: "neutral" },
          ],
        },
        {
          id: "injury_hist",
          label: "Old injuries?",
          options: [
            {
              label: "Recurring issues",
              value: "recurring",
              tag: "contributing",
            },
            { label: "Fully healed", value: "healed", tag: "neutral" },
            { label: "Clean sheet", value: "none", tag: "neutral" },
          ],
        },
      ],
    },
    {
      id: "mission",
      title: "The Mission",
      desc: "What are we building?",
      questions: [
        {
          id: "goal",
          label: "Primary Objective",
          options: [
            { label: "Get out of pain", value: "rehab", tag: "neutral" },
            {
              label: "Build aesthetic muscle",
              value: "hypertrophy",
              tag: "neutral",
            },
            { label: "General longevity", value: "health", tag: "neutral" },
          ],
        },
      ],
    },
  ],
};

// Logic to determine the "Result Archetype" based on tags
export const calculateResult = (answers) => {
  let elevated = 0;
  let contributing = 0;

  // Flatten answers and count tags
  Object.values(answers).forEach((ans) => {
    if (ans.tag === "elevated") elevated++;
    if (ans.tag === "contributing") contributing++;
  });

  if (elevated >= 1) return "REPAIR"; // High risk
  if (contributing >= 2) return "REBUILD"; // Moderate risk
  return "PERFORM"; // Low risk
};

export const RESULTS = {
  REPAIR: {
    title: "Protocol: REPAIR",
    color: "#ef4444", // Red
    summary: "System integrity alert. High stress or pain detected.",
    prescription:
      "We cannot load this system yet. Focus is 100% on pain relief, sleep hygiene, and gentle mobility until green lights return.",
  },
  REBUILD: {
    title: "Protocol: REBUILD",
    color: "#f59e0b", // Amber
    summary: "Structural drift detected.",
    prescription:
      "You have capacity, but friction is present. We will use 'Pain-Aware' progressive overload and prioritize protein to close the recovery gap.",
  },
  PERFORM: {
    title: "Protocol: PERFORM",
    color: "#10b981", // Emerald
    summary: "Systems nominal. Ready for load.",
    prescription:
      "Your recovery buckets are full. We can push intensity, aim for hypertrophy, and test 1RM standards safely.",
  },
};
